import React from "react";
import { css } from "react-emotion";
import { Hr } from "appStyles";

const container = css`
  width: 100%;
  position: relative;
  padding: 10px;
  color: black;
`;

const locationItem = css`
  margin: 10px;
`;

const title = css`
  text-align: center;
`;

const Locations = ({ locations, onClick, color }) => {
  if (!locations) return null;

  const renderOpenHours = (hours) => {
    if (!hours) return null;

    return (
      <div>
        {hours.split("|").map((hour, hourIdx) => {
          const [day, times] = hour.split(": ");
          if (!day) return null;

          return (
            <div
              key={hourIdx}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
                color: color,
              }}
            >
              <p style={{ color: color }}>{day}: </p>
              <div>
                {times === "Closed" ? (
                  <p>{times}</p>
                ) : (
                  times &&
                  times
                    .split(",")
                    .map((time, timeIdx) => <p key={timeIdx}>{time}</p>)
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={container}>
      {locations &&
        locations.map((location, idx) => {
          const { alias, address, phoneNumbers, hours } = location;

          return (
            // <div className={locationItem} key={idx} onClick={() => onClick(idx)}>
            <div className={locationItem} key={idx}>
              <p style={{ color: color }}>{alias}</p>
              <p style={{ color: color }}>
                <a
                  href={"http://maps.google.com/?q=" + address}
                  target="_blank"
                  style={{ color: color, lineHeight: "27px" }}
                >
                  {address}
                </a>
              </p>

              {phoneNumbers &&
                phoneNumbers.map((phone, phoneIdx) => {
                  const { name, number } = phone;
                  if (name) {
                    return (
                      <p
                        key={phoneIdx}
                        style={{ color: color, margin: "10px 0px" }}
                      >
                        {name} :{" "}
                        <a href={"tel:" + number} style={{ color: color }}>
                          {number}
                        </a>
                      </p>
                    );
                  }
                })}

              <br />
              {renderOpenHours(hours)}
              {/* {hours && hours.split('|').map((hour, hourIdx) => <p key={hourIdx}>{hour}</p>)} */}
              {/* <DropDown dropDownItems={hours.split('|')}/> */}

              <Hr />
            </div>
          );
        })}
    </div>
  );
};

export default Locations;
